import {commonInitialState} from "./common_store";

import {VERSIONED_API_URL} from "../../config/config";
import Http from 'axios';
function initialState() {
    return {
        ...commonInitialState,
        shifts:[],
    }
}

const getters = {
    all: state => state.all,
    shifts: state => state.shifts,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    filter: state => state.filter,
    query: state => state.query,
    totalNumber: state => state.totalNumber
};

const actions = {
    fetchShifts({commit, state}) {
        Http.get(`${VERSIONED_API_URL}/appointment-shifts`)
            .then((res) => {
                commit("setShifts", res.data.data)
            })
            .catch((e) =>{
                console.log(e);
            })
    },

    resetState({ commit }) {
        commit('resetState')
    }

}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setShifts(state,items) {
        state.shifts = items;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setServerPagination(state, item) {
        state.serverPagination = item
    },
    setTotalNumber(state, item) {
        state.totalNumber = item
    },
    setQuery(state, query) {
        state.query = query
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setFilter(state, item) {
        state.filter = item
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
